var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty-state"},[(_vm.image || _vm.defaultImage)?_c('img',{staticClass:"empty-state-img",attrs:{"src":_vm.image || _vm.defaultImage,"alt":""}}):_vm._e(),_c('div',{staticClass:"empty-state-text"},[_vm._v(_vm._s(_vm.text))]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }